var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZephyrLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 29,
    viewBox: "0 0 119 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.27921L22.2579 7.28592L20.8353 9.27433H0V7.27921Z",
    fill: "url(#paint0_linear_33_2034)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60254 11.2696L19.4096 11.2762L17.9873 13.2647H4.60254V11.2696Z",
    fill: "url(#paint1_linear_33_2034)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15723 15.1387L16.5612 15.1453L15.1388 17.1338H9.15723V15.1387Z",
    fill: "url(#paint2_linear_33_2034)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2961 21.9647C17.9184 21.9647 17.5563 21.8182 17.2893 21.5574C17.0222 21.2967 16.8721 20.943 16.8721 20.5742V18.6395C16.8721 18.5512 16.8806 18.4631 16.8976 18.3763C16.919 18.1326 17.0061 17.8989 17.1501 17.6987L26.0566 5.2783H18.4818C18.1042 5.2783 17.7421 5.13181 17.475 4.87104C17.2079 4.61026 17.0578 4.25656 17.0578 3.88776V1.9531C17.0578 1.58431 17.2079 1.2306 17.475 0.969828C17.7421 0.709051 18.1042 0.562561 18.4818 0.562561H31.6694C32.0471 0.562561 32.4093 0.709051 32.6764 0.969828C32.9434 1.2306 33.0934 1.58431 33.0934 1.9531V3.71034C33.1219 3.95299 33.0843 4.19865 32.9842 4.4225C32.9299 4.54972 32.8564 4.66834 32.7662 4.77445L23.8218 17.249H31.4839C31.8616 17.249 32.2238 17.3955 32.4909 17.6562C32.7579 17.917 32.9079 18.2707 32.9079 18.6395V20.5742C32.9079 20.943 32.7579 21.2967 32.4909 21.5574C32.2238 21.8182 31.8616 21.9647 31.4839 21.9647H18.2961Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2148 22.3207C46.2228 22.3207 48.3526 21.8646 50.1476 20.6482C51.0908 20.0096 51.1212 19.0669 50.4823 18.2762L50.0564 17.7289C49.4479 16.9382 48.6873 16.8774 47.7745 17.3335C46.6488 17.9417 45.5535 18.1242 44.6408 18.1242C41.7504 18.1242 40.1379 16.4821 40.1379 15.0832H50.6344C51.6689 15.0832 52.3382 14.6879 52.3078 13.7452C52.2165 8.69718 48.5047 5.83867 43.7584 5.83867C38.2211 5.83867 34.9961 9.76152 34.9961 14.1405C34.9961 18.6716 38.4341 22.3207 44.2148 22.3207ZM40.2292 12.3463C40.5334 10.5522 42.2068 9.79193 43.7889 9.79193C45.371 9.79193 47.0443 10.5218 47.2877 12.3463H40.2292Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4466 28.798H57.6371C58.702 28.798 59.2801 28.2202 59.2801 27.1559V19.888C60.2537 21.4693 61.9879 22.3207 64.0568 22.3207C68.3771 22.3207 71.5717 18.7932 71.5717 14.0797C71.5717 9.36619 68.3771 5.83867 64.0568 5.83867C61.9879 5.83867 60.2537 6.69014 59.2801 8.27144V7.8153C59.2801 6.75096 58.702 6.17317 57.6371 6.17317H55.4466C54.3817 6.17317 53.8036 6.75096 53.8036 7.8153V27.1559C53.8036 28.2202 54.3817 28.798 55.4466 28.798ZM62.6877 18.0634C60.5579 18.0634 59.1888 16.33 59.1888 14.0797C59.1888 11.8294 60.5579 10.096 62.6877 10.096C64.8174 10.096 66.0952 11.8598 66.0952 14.0797C66.0952 16.2996 64.8174 18.0634 62.6877 18.0634Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8269 21.9862H77.0175C78.0824 21.9862 78.6604 21.4084 78.6604 20.3441V13.6236C78.6604 11.5253 79.634 10.1873 81.2465 10.1873C82.8591 10.1873 83.4067 11.5557 83.4067 13.2586V20.3441C83.4067 21.4084 83.9848 21.9862 85.0496 21.9862H87.2402C88.3051 21.9862 88.8832 21.4084 88.8832 20.3441V12.8025C88.8832 9.63988 87.8183 5.83867 83.2546 5.83867C81.0031 5.83867 79.4819 6.81178 78.6604 8.42349V1.64213C78.6604 0.577784 78.0824 0 77.0175 0H74.8269C73.762 0 73.184 0.577784 73.184 1.64213V20.3441C73.184 21.4084 73.762 21.9862 74.8269 21.9862Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2225 28.798H96.1088C97.052 28.798 97.6605 28.4331 98.0256 27.5512L106.605 8.08899C107.092 6.96383 106.575 6.17317 105.358 6.17317H103.046C102.103 6.17317 101.494 6.59891 101.159 7.48079L98.269 15.1136L95.5003 7.5112C95.1961 6.59891 94.5876 6.17317 93.614 6.17317H91.1496C89.9022 6.17317 89.3849 6.96383 89.9022 8.08899L95.622 20.6786L92.9446 26.8822C92.4883 28.0073 92.9751 28.798 94.2225 28.798Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.933 21.9862H112.124C113.189 21.9862 113.767 21.4084 113.767 20.3441V15.3265C113.767 12.4984 114.892 11.0387 117.083 11.0387C117.326 11.0387 117.539 11.0387 117.813 11.0691C118.513 11.1604 119 10.765 119 9.85275V7.11587C119 6.53809 118.848 5.86908 118.057 5.86908C117.996 5.83867 117.631 5.83867 117.6 5.83867C116.505 5.83867 114.101 6.50768 113.584 9.57906V7.8153C113.584 6.75096 112.976 6.17317 111.941 6.17317H109.933C108.868 6.17317 108.29 6.75096 108.29 7.8153V20.3441C108.29 21.4084 108.868 21.9862 109.933 21.9862Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_2034",
    x1: 0,
    y1: 8.27677,
    x2: 21.5902,
    y2: 8.27677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "white",
    stopOpacity: 0.694
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_2034",
    x1: 4.60254,
    y1: 12.2672,
    x2: 18.9654,
    y2: 12.2672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "white",
    stopOpacity: 0.694
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33_2034",
    x1: 9.15723,
    y1: 16.1362,
    x2: 16.339,
    y2: 16.1362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "white",
    stopOpacity: 0.694
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZephyrLogo);
export default __webpack_public_path__ + "static/media/zephyr-logo.f1ed070c14c3a3a7d7585c08822a0ae1.svg";
export { ForwardRef as ReactComponent };